import { useLocation, useParams } from 'react-router-dom'

import { TasksValueObjectsTaskIdentifierEnum } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'

export const useTaskPath = () => {
  const params = useParams<'id'>()
  const { pathname } = useLocation()
  const { navigation } = useNavigation()

  if (!location || !params)
    return {
      error: true,
      path: null,
    }

  if (pathname === navigation.tasks.fullPath()) {
    return {
      error: false,
      path: (id: string, identifier: TasksValueObjectsTaskIdentifierEnum) =>
        navigation.tasks.taskIdAndIdentifier.fullPath({
          taskId: id,
          identifier: String(identifier),
        }),
    }
  }

  return {
    error: false,
    path: (id: string) =>
      navigation.employees.id.tasks.taskId.fullPath({ id: String(params.id), taskId: id }),
  }
}
